const TermsPage = () => {
  return (
    <div className="pt-20 min-h-screen" data-testid="terms-page">
      {/* Header */}
      <section className="py-16 border-b border-white/5">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
          <span className="text-sm uppercase tracking-widest text-[#D4AF37]">Legal</span>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mt-4 font-serif">
            Terms of Service
          </h1>
          <p className="text-muted-foreground mt-4">
            Gold Spot Tax
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="space-y-8">
            
            <div className="bg-[#0A0A0A] border border-white/5 p-6">
              <p className="text-muted-foreground"><strong className="text-white">Business Name:</strong> Gold Spot Tax</p>
              <p className="text-muted-foreground mt-2"><strong className="text-white">Phone:</strong> 202-704-2459</p>
              <p className="text-muted-foreground mt-2"><strong className="text-white">Address:</strong> 738 Longfellow St NW Unit 107, Washington, DC</p>
            </div>

            <div>
              <p className="text-muted-foreground leading-relaxed">
                We provide tax preparation and related services. By using our website, you agree to:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-3 mt-4 ml-4">
                <li>Provide accurate information</li>
                <li>Not use our services for illegal purposes</li>
                <li>Accept that services are based on information you provide</li>
              </ul>
            </div>

            <div>
              <p className="text-muted-foreground leading-relaxed">
                We may update these terms at any time.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
